import React from 'react'
import { Button, Space } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faArrowLeft,
  faClipboardCheck,
  faFileMedical,
  faStethoscope
} from '@fortawesome/free-solid-svg-icons'

/**
 * FeatureButtonsRow component for displaying feature buttons
 * @param {Object} props
 * @param {Function} props.setExaminationModalOpen - Function to set examination modal open state
 * @param {Function} props.setClinicalNotesModalOpen - Function to set clinical notes modal open state
 * @param {Function} props.setMedicalHistoryModalOpen - Function to set medical history modal open state
 * @param {Function} props.handleBack - Function to handle back button click
 * @param {boolean} props.isExamination - Whether this is being used in an examination context
 * @param {boolean} props.hideBackButton - Whether to hide the back button
 */
const FeatureButtonsRow = ({
  setExaminationModalOpen,
  setClinicalNotesModalOpen,
  setMedicalHistoryModalOpen,
  handleBack,
  isExamination,
  hideBackButton = false
}) => {
  const buttonStyle = {
    height: '40px',
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    padding: '0 16px',
    fontWeight: 500,
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
    transition: 'all 0.3s ease'
  }

  return (
    <Space size={12} wrap>
      {!hideBackButton && (
        <Button
          style={{
            ...buttonStyle,
            background: '#f5f5f5',
            borderColor: '#d9d9d9',
            color: '#595959'
          }}
          icon={<FontAwesomeIcon icon={faArrowLeft} style={{ color: '#595959' }} />}
          onClick={handleBack}
        >
          Back
        </Button>
      )}

      <Button
        style={{
          ...buttonStyle,
          background: '#e6f7ff',
          borderColor: '#91d5ff',
          color: '#1890ff'
        }}
        icon={<FontAwesomeIcon icon={faStethoscope} style={{ color: '#1890ff' }} />}
        onClick={() => setExaminationModalOpen(true)}
      >
        Start A Consult
      </Button>

      <Button
        style={{
          ...buttonStyle,
          background: '#f6ffed',
          borderColor: '#b7eb8f',
          color: '#52c41a'
        }}
        icon={<FontAwesomeIcon icon={faClipboardCheck} style={{ color: '#52c41a' }} />}
        onClick={() => setClinicalNotesModalOpen(true)}
      >
        Clinical Notes
      </Button>

      <Button
        style={{
          ...buttonStyle,
          background: '#fff7e6',
          borderColor: '#ffd591',
          color: '#fa8c16'
        }}
        icon={<FontAwesomeIcon icon={faFileMedical} style={{ color: '#fa8c16' }} />}
        onClick={() => setMedicalHistoryModalOpen(true)}
      >
        Medical History
      </Button>
    </Space>
  )
}

export default FeatureButtonsRow 